export interface CachedDraftData {
  text: string;
  model: string;
  status: "success" | "error";
  error?: string;
}
export interface CachedSegmentWork {
  drafts?: Record<"A" | "B" | "C", CachedDraftData | null>;
  mergedHtml?: string;
}
export function getSegmentDraftCache(draftCaches: Record<string, Record<string, unknown>>, docId: string, segmentId: string): CachedSegmentWork | null {
  const docCache = draftCaches[docId];
  if (!docCache) return null;
  const entry = docCache[segmentId];
  if (!entry || typeof entry !== "object") return null;
  return entry as CachedSegmentWork;
}
export function withSegmentDraftCache(draftCaches: Record<string, Record<string, unknown>>, docId: string, segmentId: string, work: CachedSegmentWork): Record<string, Record<string, unknown>> {
  const existing = draftCaches[docId]?.[segmentId] as CachedSegmentWork | undefined || {};
  const merged: CachedSegmentWork = {
    ...existing,
    ...work
  };
  if (work.drafts) {
    merged.drafts = {
      ...(existing.drafts || {
        A: null,
        B: null,
        C: null
      }),
      ...work.drafts
    };
  }
  const docCache = {
    ...(draftCaches[docId] || {}),
    [segmentId]: merged
  };
  return {
    ...draftCaches,
    [docId]: docCache
  };
}
export function withoutSegmentDraftCache(draftCaches: Record<string, Record<string, unknown>>, docId: string, segmentId: string): Record<string, Record<string, unknown>> {
  const docCache = {
    ...(draftCaches[docId] || {})
  };
  delete docCache[segmentId];
  return {
    ...draftCaches,
    [docId]: docCache
  };
}